/**
 * On s'amaga el botó flotant de Miranda (`MirandaFAB`) per no tapar controls de la pàgina.
 *
 * D7 (runbook 4): a `/whatsapp/<id>` per sota de `lg` el botó (fix a baix a la dreta, `z-[60]`)
 * tapava «Obre a WhatsApp» del compositor i «Desa la nota» del `Sheet` del panell (inferior a
 * mòbil, dret de `md` a `lg`), que queda per sota (`z-50`). Allà la secció «Miranda» del panell
 * ja té «Pregunta a Miranda» i la barra lateral hi porta igualment. Des de `lg` no hi ha `Sheet`
 * (el panell és una columna) i el botó es queda.
 */

/** `/whatsapp/<id>` (amb o sense barra final); la llista `/whatsapp` no compta. */
const WHATSAPP_CONVERSATION_ROUTE = /^\/whatsapp\/[^/]+\/?$/;

/**
 * El botó és només per a qui ha entrat: cal un usuari verificat (`useAuth`) i no pas només un
 * token desat. Amb el token però sense usuari l'app ensenya «No s'ha pogut connectar» o el
 * carregant, i el botó no hi ha de sortir a sobre. Tampoc a les rutes públiques: un hoste amb
 * un token vell al mòbil no ha de veure Miranda al formulari.
 */
export function canShowMirandaFab(state: {
  isAuthenticated: boolean;
  hasToken: boolean;
  onPublicRoute: boolean;
}): boolean {
  return state.isAuthenticated && state.hasToken && !state.onPublicRoute;
}

export interface FabVisibilityInput {
  pathname: string;
  /** La finestra és més estreta que `lg` (1024 px). */
  belowLg: boolean;
}

export function shouldHideMirandaFab({ pathname, belowLg }: FabVisibilityInput): boolean {
  return belowLg && WHATSAPP_CONVERSATION_ROUTE.test(pathname);
}
